import { ComponentView, DelegatedObservableArrayChangeListenner, ObservableArray, View } from "binder"
import { chartData, PieChartViewModel } from "./pieChart-viewModel"
declare var Highcharts:any;
export class PieChartView extends ComponentView<PieChartViewModel>{
    GetViewUniqueId(): string {
        return "V-68039D84-BE2D-4339-9E43-CEABB4A294DF"
    }
    loadHtml(): string {
        let element = require('./pieChart.html').default;
        let style = require('./pieChart.less');
        return element;
    }
    constructor() {
       super();
    }

    private observer : DelegatedObservableArrayChangeListenner;
    public set chartdata(v: ObservableArray<chartData>) {
        if(this.chartdata){
            this.chartdata.removeChangeListenner(this.observer);
        }
        this._chartdata = v; 
        if(this.chartdata){
            this.observer = new DelegatedObservableArrayChangeListenner(this,()=>this.render());
            this.chartdata.addChangeListenner(this.observer);
            this.render();
        }
    } public get chartdata(): ObservableArray<chartData> { return this._chartdata;} private _chartdata: ObservableArray<chartData>;
    public set legend(v: boolean) { this._legend = v; this.render(); } public get legend(): boolean { return this._legend;} private _legend: boolean;
    
    private _porentElement:any;
    onRenderCompleted(){
        this._porentElement = this.firstlevelElement.querySelector('.V-68039D84-BE2D-4339-9E43-CEABB4A294DF');
        this.render();
    }

    render(){
        if(this._porentElement==null || this.chartdata == null)
            return;
        let config = 
        {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie',
                styledMode: true
            },
            legend : {
                enabled:true,
                layout: 'horizontal',
                align: 'center',
                verticalAlign: 'bottom',
                floating: false,
                borderWidth: 1,
                backgroundColor: '#FFFFFF',
                shadow: true
            },
            credits: {
                enabled: false
            },
            
            tooltip: {
                formatter: this.formatter,
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false,
                        format: '<b>{point.name}</b>: {point.y}'
                    },
                    showInLegend: this.legend
                }
            },
            series: [{
                name: 'Amount',
                colorByPoint: true,
                data: this.chartdata.map(x=>{
                    return {
                        name:x.name,
                        y:x.amount,
                        selected:false,
                        tooltip:x.tooltip
                    }
                })
            }]
        };
        
        let a = Highcharts.chart(this._porentElement, config );
        // a.setSize(null,null);
    }
    formatter(a,b){
        let t = <any>this;
        if(t.point.options.tooltip ==''){
            return `${t.series.name}: <b>${t.point.y}</b>`
        }else{
            return t.point.options.tooltip;
        }
    }
}
